import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { NewsCard, NewsGroup } from "../../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../../utils/environment";
import { getCategoryById } from "../../../CreateNewItem/CreateNewCategory/service/category.service";
import { getNewsByCategoryPage } from "../../../news/service/news.service";
import CategoryMainNews from "../categoryMainNews";

const categoryId = process.env.REACT_APP_HOT_NEWS;
const pageCount = process.env.REACT_APP_HOT_NEWS_P_COUNT;
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");

  const handleChangeTag = (tag) => {
    props.setTagData(tag);
  };
  const onChangeMenu = (category) => {
    // onChangeCategory(category);
    props.setCategoryData(category);
  };

  useEffect(() => {
    // console.log("categoryId", categoryId);

    async function fetchPageData() {
      try {
        let res = await getCategoryById(categoryId);
        // console.log("categoryData", res);
        if (res?.data) {
          setMenu(res?.data);
          let response = await getNewsByCategoryPage(
            categoryId,
            pageCount,
            lan
          );
          // console.log("cat_response", response);
          if (response?.data) {
            setNews(response?.data?.news);
          } else {
            setNews([]);
          }
        } else {
          setNews([]);
        }

        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
    setIsLoading(true);
    fetchPageData();
  }, []);

  return (
    <>
      <NewsGroup
        data={{
          titleName: menu?.name?.[lan] || "",
          linkName:
            lan === "en"
              ? "More " + menu?.name?.[lan]
              : "තවත් " + menu?.name?.[lan],
        }}
        onClickViewNews={() => {
          props.history.push("/" + categoryId);
          props.setMenuName(categoryId);
        }}
      >
        <div className="news-row">
          {/* {!isLoading &&
            news.map((item, index) => (
              <React.Fragment key={index}>
                <NewsCard
                  data={{ type: "small", isBorder: true }}
                  item={item}
                  onClick={() => {
                   //  props.history.push("/news-view");
                  }}
                />

                {(index + 1) % 2 === 0 && <hr className="news-separator" />}
              </React.Fragment>
            ))} */}

          <div className="container">
            <div className="row">
              {isLoading && (
                <NewsCard data={{ type: "loading", isBorder: true }} />
              )}
              {/* {!isLoading &&
                news
                  .filter(
                    (item) => item.title?.[lan] && item.title[lan].trim() !== ""
                  )
                  .map((item, index) => (
                    <>
                      <div className="col-md-6 news-row" key={index}>
                        <NewsCard
                          data={{ type: "medium", isBorder: true }}
                          item={item}
                          onClick={() => {
                            // props.history.push("/news-view");
                            props.history.push(
                              `/news-view/${item?.news_id}/${item?.category}`
                            );
                          }}
                        />
                      </div>

                      {(index + 1) % 2 === 0 && (
                        <div className="col-12">
                          <hr className="news-separator" />
                        </div>
                      )}
                    </>
                  ))} */}
              {!isLoading &&
                news.map((item, index) => {
                  // Check if the item has updates
                  const hasUpdates =
                    Array.isArray(item.updates) && item.updates.length > 0;

                  // If updates exist, use the latest update (or modify as needed)
                  const displayItem = hasUpdates
                    ? { ...item, ...item.updates[item.updates.length - 1] }
                    : item;

                  return (
                    <React.Fragment key={index}>
                      <div className="col-md-6 news-row">
                        <NewsCard
                          data={{
                            type: "medium",
                            isBorder: true,
                            isUpdate: hasUpdates,
                          }}
                          item={displayItem}
                          onClick={() => {
                            if (item?.keywords?.[lan]) {
                              props.history.push(
                                `/${item?.keywords?.[lan]}/${item?.news_id}`
                              );
                            } else {
                              const generatedSlug = item?.title?.[lan]
                                ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                                ?.replace(/\//g, "")
                                ?.replace(/\s*-\s*/g, " ")
                                ?.trim()
                                .split(/\s+/)
                                .slice(0, 5)
                                .join("-")
                                .replace(/-+/g, "-");
                              props.history.push(
                                `/${generatedSlug}/${item?.news_id}`
                              );
                            }
                          }}
                          onChangeTag={handleChangeTag}
                        />
                      </div>

                      {(index + 1) % 2 === 0 && (
                        <div className="col-12">
                          <hr className="news-separator" />
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
